export default __webpack_public_path__ + "static/assets/7ab53f9bcf39c5cd51b67af11a947556.gif";